const notificationDropdown = {
  title: "Tilkynningar",
  loading: "Hleð tilkynningum...",
  loadFailed: "Ekki tókst að sækja tilkynningar",
  empty: "Engar tilkynningar",
  markAllAsRead: "Merkja allt lesið",
  viewAll: "Sjá allt",
  viewAllNotifications: "Sjá allar tilkynningar",
};

export default notificationDropdown;
